enum OEMeetingState {
  IN_PROGRESS = 'Join',
  RECORDED = 'Watch',
}

export default OEMeetingState;
